<div class="ccselection-bg">
  <div class="ccselection-heading">
    <h3>Character Selection</h3>
    <div class="header-buttons">
      <button class="btn btn-theme" (click)="selectAndAcceptAndReject(invitationdetail[0], 'REJECTED')">Decline</button>
      <button class="close-button" (click)="closeModal()"><img src="assets/icons/icon-close.svg" alt="Close"></button>
    </div>
  </div>

  <h4>PENDING GAME INVITATIONS</h4>
  @for (item of characterList; track item) {
    <div class="cport-card">
      <div class="cport-card-innner">
        <div class="cport-card-game-profile">
          <div class="formbold-file-input">
          <img [src]="
                    item.cropped_image
                      ? imageurl + item.cropped_image
                      : 'assets/main/OIP.jpg'
                  " class="img" alt="Profile Image" />
          </div>
        </div>
        <div class="cport-card-content">
          <div class="cport-card-heading">
            <h3>{{ item.nickname }} @if (item.game_details[0]?.game_name) {
              <span class="text-success">{{ '( In Game )'
              }}</span>
            }</h3>
          </div>
          <ul>
            <li><span>Level:</span> {{ item.primary_class_level }}</li>
            <li><span>Race:</span> {{ item.race }}</li>
            <li><span>Class:</span> {{ item.primary_class }}</li>
            <li><span>Alignment:</span> {{ item.alignment }}</li>
          </ul>
          <ul>
            <li><span>Strength:</span> {{ item.strength }}</li>
            <li><span>Intelligence:</span> {{ item.intelligence }}</li>
            <li><span>Wisdom:</span> {{ item.wisdom }}</li>
            <li><span>Dexterity:</span> {{ item.dexterity }}</li>
            <li><span>Constitution:</span> {{ item.constitution }}</li>
            <li><span>Charisma:</span>{{ item.charisma }}</li>
          </ul>
          <ul>
            <li>
              <span>Game:</span>
              @if (item.game_details[0]?.game_name) {
                <span>
                {{ item.game_details[0]?.game_name }}</span>
              }
            </li>
          </ul>
        </div>
        <div class="cport-card-btn-sec">
          <button class="btn btn-green player-list-btn" [disabled]="isSubmitting"
            (click)="selectAndAcceptAndReject(invitationdetail[0],'ACCEPTED',item)">
            Select
          </button>
        </div>
      </div>
    </div>
  }
  @if (planUsage) {
    <div class="btn-add-sec">
    @if ((planUsage && planUsage.subscription_features.max_active_characters > planUsage.usage.characters_created)) {
      <button class="btn btn-green" (click)="addnewplayer(invitationId)"
        >
        New
      </button>
    } @else {
      <button class="btn btn-green" (click)="navigateToSubscribe()">Subscribe</button>
    }
  </div>
}
</div>